// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"Layout_layoutWrapper__ZajnL"};